import { Spacing } from '@styles/theme';

const FIELD_TYPES: string[] = ['input', 'base-url'];

const GROUP_SPACE: Spacing = 6;
const ROW_SPACE: Spacing = 4;

// Rows of one group sit 16px apart, group boundaries 24px. A heading binds to
// whatever it labels, and the last item adds nothing since the footer has its own space.
export const getSpaceBelowAuthInfoItem = (
  item: { type: string },
  nextItem: { type: string } | undefined
): Spacing => {
  if (!nextItem) {
    return 0;
  }
  if (item.type === 'section-heading') {
    return ROW_SPACE;
  }
  return FIELD_TYPES.includes(item.type) && FIELD_TYPES.includes(nextItem.type)
    ? ROW_SPACE
    : GROUP_SPACE;
};

// Prefix and postfix let the user type only the middle of a URL; options carry
// whole URLs, so the two cannot both apply.
export const getBaseUrlAffixes = (
  item: { prefix?: string; postfix?: string; options?: unknown[] } | undefined
): { prefix: string; postfix: string } => {
  if (item?.options?.length) {
    return { prefix: '', postfix: '' };
  }
  return { prefix: item?.prefix ?? '', postfix: item?.postfix ?? '' };
};

export const getDefaultBaseUrl = (
  items: { type: string; options?: { label: string; value: string; isDefault?: boolean }[] }[]
): string | undefined => {
  const baseUrlItem = items.find((item) => item.type === 'base-url' && item.options?.length);
  return baseUrlItem?.options?.find((option) => option.isDefault)?.value;
};

// Read back off the base URL rather than stored, so typing over the field leaves
// nothing selected and a reconnect preselects whatever the saved URL matches.
export const getSelectedBaseUrlOption = (
  baseUrl: string | undefined,
  options: { label: string; value: string }[] | undefined
): string | null => {
  if (!baseUrl || !options?.length) {
    return null;
  }
  return options.find((option) => option.value === baseUrl)?.value ?? null;
};

const TRAILING_EMPTY_PARAGRAPHS = /(?:<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>)+$/i;

// The text editor writes a blank last line as `<p></p>`, which picks up the
// empty-paragraph padding in HtmlContent. Blank lines in the middle are deliberate.
export const stripTrailingEmptyParagraphs = (html: string): string =>
  html.replace(TRAILING_EMPTY_PARAGRAPHS, '');
